import { AuthGuard } from '@repo/user-session';
import { GetStaticPaths, GetStaticPathsResult, GetStaticProps, GetStaticPropsContext } from 'next';
import { useRouter } from 'next/router';
import { useIsomorphicLayoutEffect } from 'react-use';

import { LogoLayout } from '@/components/layout/Layout';
import { SimpleFooter } from '@/components/layout/SimpleFooter';
import { SimpleTermsContent } from '@/components/simple-terms/SimpleTermsContent';
import { AUTO_LOGIN_CODE_KEY } from '@/components/tax-refund/common/data/auth-info';
import { SIMPLE_TERMS_PATHS } from '@/lib/constants/paths';

const SimpleIndisApplyPage = ({ corpType }: { corpType: 'indis' | 'corps' }) => {
  const router = useRouter();
  useIsomorphicLayoutEffect(() => {
    if (!router.isReady) return;

    const code = router.query.code;
    if (code) {
      sessionStorage.setItem(AUTO_LOGIN_CODE_KEY, code as string);
    }
  }, [router]);

  return <SimpleTermsContent corpType={corpType} />;
};

SimpleIndisApplyPage.getLayout = (page: React.ReactNode) => {
  return (
    <AuthGuard logoutPagePath={SIMPLE_TERMS_PATHS.토큰유효시간만료}>
      <LogoLayout footerContent={<SimpleFooter />}>{page}</LogoLayout>
    </AuthGuard>
  );
};

export default SimpleIndisApplyPage;

export const getStaticPaths: GetStaticPaths = () => {
  const corpTypes: string[] = ['indis', 'corps'];
  const paths: GetStaticPathsResult['paths'] = corpTypes.map((corpType) => ({
    params: { corpType }
  }));
  return {
    paths,
    fallback: false
  };
};

export const getStaticProps: GetStaticProps = (context: GetStaticPropsContext) => {
  if (!context.params) {
    return {
      notFound: true
    };
  }

  const { corpType } = context.params;

  return {
    props: {
      corpType
    }
  };
};
